export const isPlagiarismEligibleLevel = (levelValue, levels = []) => {
   const selectedLevel = levels.find(({ value }) => String(value) === String(levelValue));
   const levelName = String(selectedLevel?.name ?? '').trim();

   return /\bgrade\s*(9|10|11|12)\b/i.test(levelName)
      || /^\s*(9|10|11|12)\s*$/i.test(levelName);
};

export const isPlagiarismCheckerEnabled = (value) => (
   value === true || value === 1 || value === '1'
);
